import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { MessageCircle } from "lucide-react";
import SmoothScroll from "@/components/SmoothScroll";
import ErrorBoundary from "@/components/ErrorBoundary";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import { BtnPrimary } from "@/components/Btn";
import usePageMeta from "@/hooks/usePageMeta";
import { COMPANY } from "@/config/company";

import Home from "@/pages/Home";
import ChiSiamo from "@/pages/ChiSiamo";
import Servizi from "@/pages/Servizi";
import Lavori from "@/pages/Lavori";
import News from "@/pages/News";
import Contatti from "@/pages/Contatti";
import InfoLegal from "@/pages/InfoLegal";

function WhatsAppFab() {
  return (
    <a
      href={COMPANY.whatsappHref || "/contatti#modulo-preventivo"}
      data-testid="whatsapp-fab"
      aria-label="Scrivici su WhatsApp"
      className="group fixed bottom-5 right-5 z-40 flex items-center gap-3 border border-white/15 bg-steel/85 py-2.5 pl-3 pr-3 backdrop-blur transition-colors duration-300 hover:border-molten md:pr-4"
    >
      <span className="relative flex size-9 items-center justify-center">
        <MessageCircle className="size-5 text-white transition-colors duration-300 group-hover:text-molten" />
        <span className="absolute -right-0.5 -top-0.5 size-2 rounded-full bg-molten" />
      </span>
      <span className="hidden font-tech text-[10px] uppercase tracking-[0.25em] text-white/70 group-hover:text-white md:block">
        WhatsApp
      </span>
    </a>
  );
}

function NotFound() {
  usePageMeta("Pagina non trovata — MMC S.r.l.", "La pagina richiesta non esiste.");
  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-8 px-6 text-center">
      <p className="font-tech text-xs uppercase tracking-[0.3em] text-molten">Errore 404</p>
      <h1 className="font-display text-6xl font-semibold uppercase tracking-tight sm:text-7xl">
        Pagina <span className="text-stroke">assente</span>
      </h1>
      <p className="max-w-md text-fog">La struttura che cerchi non è in questo cantiere. Torniamo alla home?</p>
      <BtnPrimary to="/" testid="notfound-home-btn">
        Torna alla Home
      </BtnPrimary>
    </main>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <SmoothScroll>
          <div className="min-h-screen bg-ink font-sans text-white">
            <Nav />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/chi-siamo" element={<ChiSiamo />} />
              <Route path="/servizi" element={<Servizi />} />
              <Route path="/lavori-realizzati" element={<Lavori />} />
              <Route path="/news" element={<News />} />
              <Route path="/contatti" element={<Contatti />} />
              <Route path="/informazioni-legali" element={<InfoLegal />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
            <Footer />
            <WhatsAppFab />
            <Toaster position="bottom-center" theme="dark" toastOptions={{ style: { borderRadius: 0 } }} />
          </div>
        </SmoothScroll>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
